import { STATUS_STEPS } from "@/lib/api";
import { Check } from "lucide-react";

export function Timeline({ status }) {
  const currentIndex = STATUS_STEPS.findIndex((s) => s.key === status);

  return (
    <div className="w-full overflow-x-auto pb-2" data-testid="project-timeline">
      <div className="flex items-center min-w-max gap-1">
        {STATUS_STEPS.map((step, i) => {
          const done = i < currentIndex;
          const active = i === currentIndex;
          return (
            <div key={step.key} className="flex items-center">
              <div className="flex flex-col items-center gap-2">
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-xs font-medium border transition-colors ${
                    active
                      ? "bg-gold text-black border-gold shadow-[0_0_20px_rgba(212,175,55,0.5)]"
                      : done
                      ? "bg-white/10 text-white border-white/30"
                      : "bg-transparent text-white/30 border-white/10"
                  }`}
                >
                  {done ? <Check className="w-4 h-4" /> : i + 1}
                </div>
                <span
                  className={`text-[11px] uppercase tracking-wider whitespace-nowrap ${
                    active ? "text-gold" : done ? "text-white/60" : "text-white/25"
                  }`}
                >
                  {step.label}
                </span>
              </div>
              {i < STATUS_STEPS.length - 1 && (
                <div className={`w-8 sm:w-14 h-px mx-1 mb-6 ${i < currentIndex ? "bg-gold/50" : "bg-white/10"}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
